import React, { createContext, useContext, useState } from 'react';

const SelectedContext = createContext();

export const SelectedProvider = ({ children }) => {
  const [selectedListStyle, setSelectedListStyle] = useState('');
  const [selectedView, setSelectedView] = useState('');
  const [selectedItems, setSelectedItems] = useState([]);
  const [importVisible, setImportVisible] = useState(false);
  const [scanVisible, setScanVisible] = useState(false);
  const [showComponent, setShowComponent] = useState(false);
  const [showAssign, setShowAssign] = useState(false);
  const [showScanWindow, setShowScanWindow] = useState(false);
  const [extractVisible, setExtractVisible] = useState(false);
  const [scanTotal, setScanTotal] = useState(0);
  const [showExtractProgress, setExtractProgressVis] = useState(false);
  const [selectedUnclassRow, setSelectedUnclassRow] = useState(null);
  const [selectedImportRow, setSelectedImportRow] = useState(null);
  const [selectedProjectRow, setSelectedProjectRow] = useState(null);
  const [selectedDBRow, setSelectedDBRow] = useState(null);
  const [visibleColumns, setVisibleColumns] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [dataToExport, setDataToExport] = useState(null);
  const [globalFilterFields, setGlobalFilterFields] = useState([]);
  const [globalFilters, setGlobalFilters] = useState(null);
  const [tableData, setTableData] = useState(null);
  const [nonFilterData, setNonFilterData] = useState(null);
  const [emptyCellDisabled, setEmptyCellDisabled] = useState(false);
  const [isCtrlPressed, setIsCtrlPressed] = useState(false);
  const [isShiftPressed, setIsShiftPressed] = useState(false);
  const [scanMin, setScanMin] = useState(false);
  const [importMin, setImportMin] = useState(false);
  const [extractMin, setExtractmin] = useState(false);
  const [windowType, setWindowType] = useState('');
  const trueValues = ['true', '1', 'yes', 'on'];
  const [projectSelected, setProjectSelected] = useState(trueValues.includes(sessionStorage.getItem('projectSelected')));
  const [closed, setClosed] = useState(false);
  const [docIdentified, setDocIdentified] = useState(false);
  const [docIdenMessage, setDocIdenMessage] = useState('');
  const [fcToggle, setFCToggle] = useState(false);
  const [fcCreateVisible, setFcCreateVisible] = useState(false)
  const [moveVisible, setMoveVisible] = useState(false)
  const [docSearch, setDocSearch] = useState(false)
  const [deleteFileSwitch, setDeleteFileSwitch] = useState(false)
  const [folderLoadSwitch, setFolderLoadSwitch] = useState(false)
  const [fcSwitch, setFCSwitch] = useState(false)
  const [groupLoading, setGroupLoading] = useState(true);
  const [childFileLoading, setChildFileLoading] = useState(true);
  const [childFolderLoading, setChildFolderLoading] = useState(true);
  const [selectedFile, setSelectedFile] = useState(null);

  const skelData = [
    { },
    { },
    { },
    { },
    { },
    { },
    { }
  ];

  const skelDataFilFol = [
    { },
    { },
    { }
  ];
  
  const updateSelectedView = (viewVisibility) => {
    setSelectedView(viewVisibility);
    sessionStorage.setItem('selectedView', viewVisibility);
  };

  const updateSelectedListStyle = (listStyle) => {
    setSelectedListStyle(listStyle);
    sessionStorage.setItem('selectedListStyle', listStyle);
  };

  const toggleItemSelection = (item, sortedAllFake) => {
    // setSelectedItems((prevSelectedItems) => {
    //   const isSelected = prevSelectedItems.some((selectedItem) => selectedItem.id === item.id);
    //   if (isCtrlPressed) {
    //     if (isSelected) {
    //       return prevSelectedItems.filter((selectedItem1) => selectedItem1.id !== item.id);
    //     } else {
    //       return [...prevSelectedItems, item];
    //     }
    //   } 
    //   else if (isShiftPressed) {
    //     const clickedIndex = item.sort_id;
    //     let minIndex = Number.MAX_VALUE;
    //     for (const item of prevSelectedItems) {
    //       if (item.sort_id < minIndex) {
    //         minIndex = item.sort_id;
    //       }
    //     }
    //     let maxIndex = -1;
    //     for (const item of prevSelectedItems) {
    //       if (item.sort_id > maxIndex) {
    //         maxIndex = item.sort_id;
    //       }
    //     }

    //     if (maxIndex >= 0 && clickedIndex >= 0) {
    //       const startIndex = Math.min(minIndex, clickedIndex);
    //       let endIndex = Math.max(maxIndex, clickedIndex);
    //       let itemsToSelect = sortedAllFake.slice(startIndex-1, endIndex);
    //       setIsShiftPressed(false);
    //       return itemsToSelect;
    //     }
    //     else {
    //       setIsShiftPressed(false);
    //       return [];
    //     }
    //   }
    //   else if (isSelected && !isCtrlPressed && !isShiftPressed && prevSelectedItems.length > 1) {
    //     return [item];
    //   }
    //   else if (isSelected && !isCtrlPressed && !isShiftPressed && prevSelectedItems.length === 1) {
    //     return [];
    //   } else {
    //     return [item];
    //   }
    // });
  };

  const toggleComponent = () => {
    setShowComponent(!showComponent);
  };

  const applyEmpFilters = () => {
    const filteredData = nonFilterData.filter(item =>
      item.heat_number === "" || item.document_name === ""
    )
    setTableData(filteredData);
    setDataToExport(filteredData)
    setEmptyCellDisabled(true);
  };

  const remAttFilters = () => {
    setTableData(nonFilterData);
  }

  return (
    <SelectedContext.Provider
      value={{
        selectedListStyle,
        setSelectedListStyle,
        selectedView,
        setSelectedView,
        selectedItems,
        setSelectedItems,
        importVisible,
        setImportVisible,
        scanVisible,
        setScanVisible,
        showComponent, 
        setShowComponent,
        showAssign, 
        setShowAssign,
        showScanWindow, 
        setShowScanWindow,
        scanTotal,
        setScanTotal,
        extractVisible,
        setExtractVisible,
        showExtractProgress,
        setExtractProgressVis,
        selectedUnclassRow,
        setSelectedUnclassRow,
        selectedImportRow,
        setSelectedImportRow,
        selectedProjectRow,
        setSelectedProjectRow,
        selectedDBRow,
        setSelectedDBRow,
        visibleColumns,
        setVisibleColumns,
        filteredData,
        setFilteredData,
        dataToExport,
        setDataToExport,
        globalFilterFields, 
        setGlobalFilterFields,
        globalFilters,
        setGlobalFilters,
        tableData,
        setTableData,
        nonFilterData,
        setNonFilterData,
        emptyCellDisabled,
        setEmptyCellDisabled,
        isCtrlPressed,
        setIsCtrlPressed,
        isShiftPressed,
        setIsShiftPressed,
        scanMin,
        setScanMin,
        importMin,
        setImportMin,
        extractMin,
        setExtractmin,
        windowType,
        setWindowType,
        projectSelected,
        setProjectSelected,
        closed,
        setClosed,
        fcSwitch, 
        setFCSwitch,
        fcToggle, 
        setFCToggle,
        fcCreateVisible,
        moveVisible,
        setMoveVisible,
        docSearch,
        setDocSearch,
        setFcCreateVisible,
        skelData,
        updateSelectedView,
        updateSelectedListStyle,
        toggleItemSelection,
        toggleComponent,
        applyEmpFilters,
        remAttFilters,
        docIdentified, 
        setDocIdentified,
        docIdenMessage, 
        setDocIdenMessage,
        deleteFileSwitch, 
        setDeleteFileSwitch,
        skelDataFilFol,
        groupLoading,
        setGroupLoading,
        folderLoadSwitch,
        setFolderLoadSwitch,
        childFileLoading,
        setChildFileLoading,
        childFolderLoading,
        setChildFolderLoading,
        selectedFile,
        setSelectedFile
      }}
    >
      {children}
    </SelectedContext.Provider>
  );
};

export const useSelectedContext = () => {
  return useContext(SelectedContext);
};